import React from "react";
import BookingAddOrUpdateContent from "../content/bookingAddOrUpdateContent";
import Layout from "../layout/Layout";

const BookingSingle = () => {
  return (
    <Layout>
      <BookingAddOrUpdateContent />
    </Layout>
  );
};

export default BookingSingle;
